import api from "../../api";
import { FETCH_DP_URL } from "../mutations/available";

export function fetchDPUrlActions ({commit}) {
	api.getSettings()
		.then(resp => {
			if(resp !== null && resp !== 'undefined') {
				commit(FETCH_DP_URL, resp)
			} else {
				commit(FETCH_DP_URL, 'http://app.dpathology.ru/')
			}
		})
}
